import { render, staticRenderFns } from "./ImportExportModal.vue?vue&type=template&id=1f88e6d2&scoped=true"
import script from "./ImportExportModal.vue?vue&type=script&lang=js"
export * from "./ImportExportModal.vue?vue&type=script&lang=js"
import style0 from "./ImportExportModal.vue?vue&type=style&index=0&id=1f88e6d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f88e6d2",
  null
  
)

export default component.exports